import { getAppConfig } from "../config";
import {
    CreditCard,
    getErrorMessageToken,
    PaymentStatus,
    ResponseTokenZeusAPI
} from "../generated/lib-domain/paymentZeus";
import * as xml from "fast-xml-parser";

export async function tokenZeus(
    body: CreditCard
): Promise<ResponseTokenZeusAPI> {
    const config = getAppConfig();

    const endPoint = config.zeus.endpointTokenApi;

    const optionsXml = {
        attributeNamePrefix: "@_",
        ignoreAttributes: false,
        encodeHTMLchar: false,
        format: false,
        indentBy: "  ",
        supressEmptyNode: false
    };

    const optionsJson = {
        attributeNamePrefix: "@_",
        ignoreAttributes: true,
        ignoreNameSpace: false,
        allowBooleanAttributes: false,
        parseNodeValue: false,
        parseAttributeValue: false,
        trimValues: true,
        decodeHTMLchar: false,
        cdataPositionChar: "\\c"
    };

    const bodyJson = {
        request: {
            "@_service": "token",
            "@_action": "newcard",
            authentication: {
                clientip: getAppConfig().zeus.clientIp
            },
            card: {
                cvv: body.securityNo,
                number: body.cardNumber,
                expires: {
                    year: "20" + body.expiresYear,
                    month: body.expiresMonth
                },
                name: ""
            }
        }
    };

    const xmlParser = new xml.j2xParser(optionsXml);
    const data = xmlParser.parse(bodyJson);

    const res = await fetch(endPoint, {
        method: "post",
        body: data,
        headers: {
            "Content-Type": "application/xml"
        }
    }).catch((error) => {
        // NOTE カード情報が入らないように重要なものだけ取り出す
        const err = {
            status: error.status,
            statusText: error.statusText,
            message: error.message
        };
        throw Error(`Zeus API Error: ${JSON.stringify(err)}`);
    });

    const responseText = await res.text();

    if (xml.validate(responseText)) {
        const jsonData = xml.parse(responseText, optionsJson);
        return {
            status: jsonData.response.result.status,
            code: jsonData.response.result.code
                ? jsonData.response.result.code.toString()
                : undefined,
            message:
                jsonData.response.result.status !== PaymentStatus.Success
                    ? getErrorMessageToken(
                          jsonData.response.result.code.toString()
                      )
                    : undefined,
            tokenKey: jsonData.response.result.token_key
                ? jsonData.response.result.token_key.toString()
                : "",
            maskedCvv: jsonData.response.result.masked_cvv
                ? jsonData.response.result.masked_cvv.toString()
                : "",
            maskedCardNumber: jsonData.response.result.masked_card_number
                ? jsonData.response.result.masked_card_number.toString()
                : "",
            cardExpiresMonth: jsonData.response.result.card_expires_month
                ? jsonData.response.result.card_expires_month.toString()
                : "",
            cardExpiresYear: jsonData.response.result.card_expires_year
                ? jsonData.response.result.card_expires_year.toString()
                : ""
        } as ResponseTokenZeusAPI;
    } else {
        return {} as ResponseTokenZeusAPI;
    }
}
